module.exports = __webpack_public_path__ + "static/media/S4N4.b7e1b60e.svg";